function windowResize() {
	return {
		restrict: "A",
		link: function(scope) {
			scope.$watch(() => {
				return window.innerWidth;
			}
			, (oldWidth, newWidth) => {
				scope.$ctrl.isMobile = (newWidth < 768) ? true : false;

				if(oldWidth > 768 && newWidth <= 768 && scope.$ctrl.windowResizeMobileCallback) {
					scope.$ctrl.windowResizeMobileCallback();
				}

				if(oldWidth < 768 && newWidth >= 768 && scope.$ctrl.windowResizeDesktopCallback) {
					scope.$ctrl.windowResizeDesktopCallback();
				}
			}
			);

			const resizeBind = function() { scope.$apply(); };

			angular.element(window).bind("resize", resizeBind);

			scope.$on("$destroy", function() {
				angular.element(window).unbind("resize", resizeBind);
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.window-resize", [])
	.directive("windowResize", windowResize).name;
